import AgencyHelper from 'features/Agency/agencyHelper';
import AgencyContractListView from 'features/Agency/components/AgencyContractListView';
import BreadcrumbHelper from 'general/components/CustomBreadcrumb/BreadcrumbHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import CustomCard from 'general/components/Others/CustomCard';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import useScrollToTop from 'hooks/useScrollToTop';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import AppRoute from 'general/constants/AppRoute';
import KTScrollCard from 'general/components/OtherKeenComponents/KTScrollCard';
import ChargeHelper from 'features/Charge/chargeHelper';
import AgencyUIHelper from 'general/helpers/AgencyUIHelper';
import BuildInfoCardView from 'features/ManageDealer/components/BuildInfoCardView';
import { AppDialogHelper } from 'general/components/AppDialog';
import ToastHelper from 'general/helpers/ToastHelper';
import useAppConfig from 'hooks/useAppConfig';
import AppConstants from 'general/constants/AppConstants';

PremiseDetailScreen.propTypes = {};

function PremiseDetailScreen(props) {
    // ---- params ----
    const { t } = useTranslation();
    const router = useRouter();
    const premiseInfoRef = useRef();
    const { user } = useSelector((state) => state.auth)
    const [containerHeight, setContainerHeight] = useState('auto');
    const premiseId = router.query?.premiseId;
    const [premiseDetail, setPremiseDetail] = useState();
    const [isReady, setIsReady] = useState(false);
    const commissionRateLandlord = useAppConfig()?.commissionRateLandlord;
    const [commissionGrounds, setCommissionGrounds] = useState([]);
    const appConfig = useAppConfig();
    const [isAdminAgency, setAdminAgency] = useState(false);

    useEffect(() => {
        setCommissionGrounds(
            appConfig.commissionRateLandlord
                ? JSON.parse(appConfig.commissionRateLandlord)
                    .map(item => ({
                        key: item.key,
                        name: item.name,
                        value: item?.value ?? 0,
                        car: item?.car ?? 0,
                        bike: item?.bike ?? 0,
                        show: item.show
                    }))
                : [{ name: '', value: 0, car: 0, bike: 0 }]
        );
    }, [appConfig]);

    const landlordCommission = useMemo(() => {
        return commissionGrounds?.find(commission => commission?.key === premiseDetail?.type);
    }, [commissionGrounds, premiseDetail])

    const areaTree = useSelector((state) => state.app.areaTree);
    const [agencyArea, setAgencyArea] = useState(null);
    const [agencyParentArea, setAgencyParentArea] = useState(null);
    useEffect(() => {
        if (areaTree && !_.isEmpty(areaTree) && premiseDetail) {
            const agencyAreaId = premiseDetail?.areaId;
            const agencyArea = ChargeHelper.Utils.getAreaById([areaTree], agencyAreaId);
            if (agencyArea?.typeCode === 'W') {
                setAgencyArea(agencyArea);
                setAgencyParentArea(ChargeHelper.Utils.getAreaById([areaTree], agencyArea?.parentId));
            } else if (agencyArea?.typeCode === 'P') {
                setAgencyParentArea(agencyArea);
            }
        }
    }, [areaTree, premiseDetail]);

    useEffect(() => {
        getPremiseDetail(premiseId);
    }, [premiseId]);

    useScrollToTop();

    useEffect(() => {
        if (premiseInfoRef.current) {
            setContainerHeight(`${premiseInfoRef.current?.offsetHeight}px`);
        }
    }, [premiseDetail, premiseInfoRef.current]);

    const contractList = useMemo(() => {
        if (!premiseDetail?.sales) return [];
        return premiseDetail.sales.flatMap(sale => sale?.contracts || []);
    }, [premiseDetail]);

    // ---- methods ----

    const getPremiseDetail = (id) => {
        AgencyHelper.API.requestGetPremiseDetail(id).then((data) => {
            if (data && Object.keys(data)?.length > 0) {
                setPremiseDetail(data);
                if (Utils.isValid(data?.agencyId)) {
                    handleGetAgencyDetail(data?.agencyId);
                } else {
                    setIsReady(true);
                }
            } else {
                router.navigate(-1);
            }
        });
    };

    const handleGetAgencyDetail = (id) => {
        AgencyHelper.API.requestAgencyDetail(id).then((res) => {
            if (Utils.isValid(res)) {
                setAdminAgency(!res?.parentAgencyId);
                setIsReady(true);
            }
        });
    }

    const handleDeletePremise = async (row) => {
        AppDialogHelper.show(
            `Xóa mặt bằng`,
            `Bạn có chắc muốn xóa mặt bằng <span class="font-weight-boldest text-gray-800">${row?.name}</span> không? Bạn vẫn có thể khôi phục sau khi đã xóa.`,
            [
                {
                    title: 'Hủy bỏ',
                    type: 'neutral',
                    onClick: () => {
                        AppDialogHelper.hide();
                    },
                },
                {
                    title: 'Xóa',
                    type: 'negative',
                    onClick: async () => {
                        AppDialogHelper.hide();
                        const isSuccess = await AgencyHelper.API.requestUpdatePremise(row?.premiseId, { status: 'DELETED' });
                        if (isSuccess) {
                            ToastHelper.showSuccess(`Xoá mặt bằng thành công`);
                            getPremiseDetail(premiseId);
                        }
                    },
                },
            ],
            false,
            AppResource.images.dialogIcons.dialogDeleteVehicle
        );
    }

    const handleActivePremise = async (row) => {
        AppDialogHelper.show(
            'Khôi phục hoạt động',
            `Bạn có chắc muốn khôi phục hoạt động mặt bằng <span class="font-weight-boldest text-gray-800">${row?.name}</span> không?`,
            [
                {
                    title: 'Hủy bỏ',
                    type: 'neutral',
                    onClick: () => {
                        AppDialogHelper.hide();
                    },
                },
                {
                    title: 'Khôi phục hoạt động',
                    type: 'success',
                    onClick: async () => {
                        AppDialogHelper.hide();
                        const isSuccess = await AgencyHelper.API.requestUpdatePremise(row?.premiseId, { status: 'AVAILABLE' });
                        if (isSuccess) {
                            ToastHelper.showSuccess(`Khôi phục hoạt động thành công`);
                            getPremiseDetail(premiseId);
                        }
                    },
                },
            ],
            false,
            AppResource.images.dialogIcons.dialogActiveAgency
        );
    }

    const typeMap = {
        CAR: "Ô tô",
        BIKE: "Xe máy"
    };

    const handleGetRentingForm = (row) => {
        const landlordCommission = row?.landlord?.commissions?.find(
            (commission) => commission?.role === 'LANDLORD'
                && row?.chargeStations?.length && row?.chargeStations?.some(station => station?.stationId === commission?.stationId)
        );
        if (!row) return 'Không xác định';

        const hasMonthlyRent = row.monthlyRent > 0;
        const hasLandlordCommission = !!landlordCommission;

        if (!hasMonthlyRent && (!hasLandlordCommission || landlordCommission?.energyCommissionValue === 0)) return 'Miễn phí';
        if (!hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Có phí';
        if (hasMonthlyRent && (!hasLandlordCommission || landlordCommission?.energyCommissionValue === 0)) return 'Có phí';
        if (hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Có phí';

        return 'Không xác định';
    };

    const premiseLandlordEnergyCommission = useMemo(() => {
        return premiseDetail?.landlord?.commissions?.find(commission =>
            commission?.role === 'LANDLORD' &&
            Array.isArray(premiseDetail?.chargeStations) &&
            premiseDetail.chargeStations.some(station => station?.stationId === commission?.stationId)
        ) || null;
    }, [premiseDetail]);

    const premiseLandlordCommission = useMemo(() => {
        return premiseDetail?.agency?.commissions?.find(commission =>
            commission?.role === 'SALE' &&
            Array.isArray(premiseDetail?.chargeStations) &&
            premiseDetail.chargeStations.some(station => station?.stationId === commission?.stationId)
        ) || null;
    }, [premiseDetail]);

    const handleGetRentingCost = (row) => {
        const landlordCommission = row?.landlord?.commissions?.find(
            (commission) => commission?.role === 'LANDLORD'
                && row?.chargeStations?.length && row?.chargeStations?.some(station => station?.stationId === commission?.stationId)
        );

        if (!row) return 'Không xác định';

        const hasMonthlyRent = row.monthlyRent > 0;
        const hasLandlordCommission = !!landlordCommission;

        if (!hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Chia sẻ doanh thu điện';
        if (hasMonthlyRent && (!hasLandlordCommission || landlordCommission?.energyCommissionValue === 0)) return 'Phí thuê cố định';
        if (hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Chi phí thuê kết hợp';

        return 'Phí thuê cố định';
    };

    const handleGetLandlordCommissionType = (row) => {
        if (!row) return 'Không xác định';

        // const landlordCommission = row?.agency?.commissions?.find(
        //     (commission) =>
        //         commission?.role === 'SALE' &&
        //         row?.chargeStations?.length &&
        //         row?.chargeStations?.some(station => station?.stationId === commission?.stationId)
        // );

        // if (!landlordCommission) return 'Hoa hồng cố định';

        // const { energyCommissionValue, energyCommissionDuration } = landlordCommission || {};
        const hasFixedCommission = row?.sales[0]?.amount > 0;
        if (hasFixedCommission && premiseDetail?.saleEnergyCommissionValue === 0 && premiseDetail?.saleEnergyCommissionDuration === 0) {
            return 'Hoa hồng cố định';
        }
        if (!hasFixedCommission && premiseDetail?.saleEnergyCommissionValue > 0 && premiseDetail?.saleEnergyCommissionDuration > 0) {
            return 'Hoa hồng theo doanh thu điện';
        }
        if (hasFixedCommission && premiseDetail?.saleEnergyCommissionValue > 0 && premiseDetail?.saleEnergyCommissionDuration > 0) {
            return 'Hoa hồng kết hợp';
        }
        return 'Hoa hồng cố định';
    };

    const handleGetFixEnergyCommission = (key, premiseLandlordCommission, premiseDetail, isAdminAgency) => {
        if (isAdminAgency) return 0;
        if (!premiseDetail?.agencyId) return '';
        let landlordCommissionObj = premiseLandlordCommission?.landlordCommission?.length && premiseLandlordCommission?.landlordCommission[0];

        if (landlordCommissionObj && landlordCommissionObj[key] !== undefined) {
            return landlordCommissionObj[key];
        }
        const fallbackCommission = commissionGrounds.find(
            (commission) => commission?.key === premiseDetail?.type
        );

        return fallbackCommission?.[key] ?? '';
    };

    const PremiseInfo = () => {
        return (
            <div
                className="row m-0 position-relative p-3 bg-white rounded-lg"
                style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    boxShadow: '0px 7px 8px -3px #0000000D',
                }}
            >
                <div className="d-flex px-0 align-items-center w-100">
                    <div className="d-flex align-items-center w-85">
                        <img
                            className="rounded-circle"
                            src={
                                premiseDetail?.avatar
                                    ? Utils.getFullUrl(premiseDetail?.avatar)
                                    : AppResource.icons.avatar.default
                            }
                            style={{
                                width: 44,
                            }}
                        />
                        <div className="d-flex flex-column ml-3 w-100">
                            <div className="d-flex align-items-center gap-2" style={{ overflow: 'hidden' }}>
                                <div
                                    className="font-weight-bolder"
                                    style={{
                                        color: AppColors.gray[800],
                                        fontSize: Utils.returnFontSize(18),
                                        fontWeight: '600',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                    }}
                                >
                                    {premiseDetail?.name}
                                </div>

                                <span className="min-w-100px">
                                    <KTLabel
                                        text={AgencyHelper.Utils.getPremiseStatusName(premiseDetail?.status)}
                                        isInline={true}
                                        size={KTLabelSize.medium}
                                        additionalClassName={`label-light-${AgencyHelper.Utils.getPremiseStatusColor(
                                            premiseDetail?.status
                                        )}`}
                                    />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex gap-3 justify-content-end ml-auto">
                        <VITableRowDropDown
                            toggleElement={
                                <a
                                    href="#"
                                    className="btn btn-sm btn-clean btn-icon h-45px w-45px hover-opacity-60"
                                    style={{ backgroundColor: AppColors.gray[200] }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                    }}
                                >
                                    <i
                                        className="fa-solid fa-ellipsis"
                                        style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                    />
                                </a>
                            }
                            menuItem={[
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-pen-to-square"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: t('edit'),
                                    click: () => {
                                        router.navigate(`edit`);
                                    },
                                    show: true,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-play"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: t('unStopWorking'),
                                    click: () => {
                                        handleActivePremise(premiseDetail);
                                    },
                                    show: premiseDetail?.status === 'DELETED',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-trash-can`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: t('Xóa mặt bằng'),
                                    click: () => {
                                        handleDeletePremise(premiseDetail);
                                    },
                                    show: premiseDetail?.status !== 'DELETED' && premiseDetail?.status !== 'RENTED',
                                },
                            ]}
                            singleBtnBgColor={AppColors.gray[200]}
                        />
                    </div>
                </div>

                <div
                    className="my-4"
                    style={{
                        borderTop: `1px dashed ${AppColors.gray[300]}`,
                    }}
                />

                {/* thong tin mat bang */}
                <div className="col-xl-12 col-lg-12 col-md-12 d-flex flex-column px-0 ">
                    <div className=" d-flex flex-lg-row flex-column flex-wrap">
                        <>
                            <div className="col-xl-6 p-0 pr-xl-3 pl-0 pr-0 my-1 d-flex flex-column gap-3">
                                {AgencyUIHelper.buildTableInfo(t('Thông tin cơ bản'), [
                                    {
                                        name: t('Tên mặt bằng'),
                                        value: premiseDetail?.name,
                                        color: AppColors.gray[800],
                                    },
                                    {
                                        name: t('Loại mặt bằng'),
                                        value: commissionRateLandlord ? JSON.parse(commissionRateLandlord)?.find(landlord => landlord?.key === premiseDetail?.type)?.name : '',
                                        color: AppColors.gray[800],
                                    },
                                    {
                                        name: t('Diện tích'),
                                        value: premiseDetail?.floorArea ? premiseDetail?.floorArea + ' m2' : '',
                                        color: AppColors.gray[800],
                                    },
                                    {
                                        name: t('Loại phương tiện'),
                                        value: premiseDetail?.vehicleTypes?.length > 0
                                            ? premiseDetail?.vehicleTypes?.map((type, index) => index === 0 ? typeMap[type] : typeMap[type].toLowerCase()).join(", ")
                                            : '',
                                        color: AppColors.gray[800]
                                    },
                                    {
                                        name: t('Chỗ đỗ xe ô tô'),
                                        value: premiseDetail?.parkingSlots ?? '',
                                        color: AppColors.gray[800],
                                    },
                                    {
                                        name: t('Phạm vi thuê'),
                                        value: premiseDetail?.rentingType ? AgencyHelper.Data.rentingTypeOptions.find(type => type.value === premiseDetail?.rentingType)?.name : '',
                                        color: AppColors.gray[800],
                                    },
                                    {
                                        name: t('Hình thức thuê'),
                                        value: handleGetRentingForm(premiseDetail),
                                        color: AppColors.gray[800],
                                    },
                                    {
                                        name: t('Hình thức tính phí'),
                                        value: handleGetRentingCost(premiseDetail),
                                        color: AppColors.gray[800],
                                        hide: handleGetRentingForm(premiseDetail) === 'Miễn phí',
                                    },
                                    {
                                        name: t('Người tạo/giới thiệu'),
                                        value: premiseDetail?.agency?.name ?? '',
                                        color: AppColors.gray[800],
                                    },
                                    {
                                        name: t('Ngày tạo'),
                                        value: Utils.formatDateTimeToString(premiseDetail.createdAt, 'DD/MM/YYYY'),
                                        color: AppColors.gray[800],
                                    },
                                ])}
                            </div>
                            <div className="col-xl-6 p-0 my-1 d-flex flex-column gap-3">
                                {AgencyUIHelper.buildTableInfo(t('Thông tin vị trí'), [
                                    {
                                        name: t('Tỉnh/Thành phố'),
                                        value: agencyParentArea?.name,
                                        color: AppColors.gray[800],
                                    },
                                    {
                                        name: t('Phường/Xã'),
                                        value: agencyArea?.name,
                                        color: AppColors.gray[800],
                                    },
                                    {
                                        name: t('Địa chỉ'),
                                        value: premiseDetail?.address,
                                        color: AppColors.gray[800],
                                    },
                                ])}
                                {AgencyUIHelper.buildTableInfo(t('Thông tin liên quan'), [
                                    {
                                        name: t('Chủ mặt bằng'),
                                        value: premiseDetail?.landlord?.name,
                                        color: AppColors.primary,
                                        action: () => {
                                            Utils.openInNewTab(`${AppRoute.landlordList}/${premiseDetail?.landlordId}`);
                                        }
                                    },
                                    {
                                        name: t('Mã trạm sạc'),
                                        value: (
                                            <div className='d-flex justify-content-end'>
                                                {premiseDetail?.chargeStations?.length ? premiseDetail?.chargeStations?.map((item, index) => {
                                                    return (
                                                        <div className='cursor-pointer'
                                                            onClick={() => {
                                                                Utils.openInNewTab(`${AppRoute.stationList}/${item?.stationId}`);
                                                            }}>
                                                            {item?.stationCode}
                                                            {index !== premiseDetail?.chargeStations?.length - 1 ? <span className='mr-1'>,</span> : <></>}
                                                        </div>
                                                    )
                                                }) : ''}
                                            </div>
                                        ),
                                        color: AppColors.primary,
                                    },
                                    {
                                        name: t('Đơn hàng liên quan'),
                                        value: (
                                            <div className='d-flex justify-content-end'>
                                                {premiseDetail?.sales?.length ? premiseDetail?.sales?.map((item, index) => {
                                                    return (
                                                        <div className='cursor-pointer'
                                                            onClick={() => {
                                                                Utils.openInNewTab(`${AppRoute.orderList}/${item?.saleId}`);
                                                            }}>
                                                            {item?.saleId}
                                                            {index !== premiseDetail?.sales?.length - 1 ? <span className='mr-1'>,</span> : <></>}
                                                        </div>
                                                    )
                                                }) : ''}
                                            </div>
                                        ),
                                        color: AppColors.primary,
                                    },
                                ])}
                                {AgencyUIHelper.buildTableInfo(t('Mô tả'), [
                                    {
                                        name: t('Thông tin mô tả'),
                                        value: premiseDetail?.description,
                                        color: AppColors.gray[800],
                                    },
                                ])}
                            </div>
                        </>
                    </div>
                </div>
            </div>
        );
    };

    if (!isReady) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            <div className="w-100">
                {BreadcrumbHelper.buildBreadcrumb([
                    {
                        title: 'Danh sách mặt bằng',
                        onPress: () => {
                            router.navigate(-1);
                        },
                    },
                    { title: 'Chi tiết mặt bằng' },
                ])}
            </div>

            <div className='m-4 mt-16'>
                {/* thong tin Mat bang */}
                <CustomCard
                    showHeader={false}
                    additionalClassName="rounded-lg overflow-hidden"
                    bgTransparent={true}
                    showBorder={false}
                    body={
                        <div className="d-xl-flex d-lg-flex">
                            <div
                                className='col-xl-9 col-12 col-lg-12 p-0 h-100'
                                ref={premiseInfoRef}
                            >
                                {/* thong tin Mat bang */}
                                <PremiseInfo />
                            </div>
                            <KTScrollCard
                                className="col-xl-3 col-lg-12 col-md-12 m-0 pl-lg-4 pl-0 pr-0 mb-sm-5 mb-lg-0 mt-5 mt-lg-0"
                                containerHeight={containerHeight}
                            >
                                {handleGetRentingForm(premiseDetail) !== 'Miễn phí' && (
                                    <BuildInfoCardView
                                        bgIconColor="#32ADE6"
                                        icon={<i className="fas fa-house-chimney-user fa-2x text-white" />}
                                        name="Phí thuê mặt bằng"
                                        contents={[
                                            {
                                                value: handleGetRentingCost(premiseDetail),
                                                description: 'Hình thức tính phí',
                                            },
                                            {
                                                description: '',
                                                value: '<div style="border-top: 1px dashed #DBDFF1;"></div>',
                                                hide: handleGetRentingCost(premiseDetail) === 'Phí thuê cố định',
                                            },
                                            {
                                                value: premiseLandlordEnergyCommission
                                                    ? Utils.formatNumber(premiseLandlordEnergyCommission?.energyCommissionValue) + ' VNĐ/kWh'
                                                    : '',
                                                description: 'Mức chia sẻ theo kW điện',
                                                hide: handleGetRentingCost(premiseDetail) === 'Phí thuê cố định',
                                            },
                                            {
                                                description: '',
                                                value: '<div style="border-top: 1px dashed #DBDFF1;"></div>',
                                                hide: handleGetRentingCost(premiseDetail) === 'Chia sẻ doanh thu điện',
                                            },
                                            {
                                                value: premiseDetail?.rentingType === 'FULL'
                                                    ? Utils.formatNumber(premiseDetail?.monthlyRent) + ' VNĐ/tháng'
                                                    : Utils.formatNumber(premiseDetail?.slotRent) + ' VNĐ/chỗ đỗ/tháng',
                                                description: 'Số tiền cố định',
                                                hide: handleGetRentingCost(premiseDetail) === 'Chia sẻ doanh thu điện',
                                            },
                                            {
                                                value: Utils.formatDateTimeToString(premiseDetail?.fullfillmentDate, 'DD/MM/YYYY'),
                                                description: 'Ngày bắt đầu tính phí thuê',
                                                hide: handleGetRentingCost(premiseDetail) === 'Chia sẻ doanh thu điện',
                                            },
                                        ]}
                                        additionalClassName="mb-4"
                                    />
                                )}

                                {user?.agency?.primaryRole !== AppConstants.userAgencyType.landlord &&
                                    < BuildInfoCardView
                                        bgIconColor="#FF9500"
                                        icon={<i className="fas fa-badge-percent fa-2x text-white" />}
                                        name="Hoa hồng giới thiệu mặt bằng"
                                        contents={[
                                            {
                                                value: handleGetLandlordCommissionType(premiseDetail),
                                                description: 'Hình thức trả hoa hồng',
                                            },
                                            {
                                                description: '',
                                                value: '<div style="border-top: 1px dashed #DBDFF1;"></div>',
                                                hide: handleGetLandlordCommissionType(premiseDetail) === 'Hoa hồng cố định',
                                            },
                                            {
                                                value: Utils.formatNumber(isAdminAgency ? 0 : premiseDetail?.saleEnergyCommissionValue) + ' VNĐ/kWh',
                                                description: 'Mức chia sẻ theo kW điện',
                                                hide: handleGetLandlordCommissionType(premiseDetail) === 'Hoa hồng cố định',
                                            },
                                            {
                                                value: Utils.formatNumber(isAdminAgency ? 0 : premiseDetail?.saleEnergyCommissionDuration) + ' Tháng',
                                                description: 'Thời gian áp dụng',
                                                hide: handleGetLandlordCommissionType(premiseDetail) === 'Hoa hồng cố định',
                                            },
                                            {
                                                description: '',
                                                value: '<div style="border-top: 1px dashed #DBDFF1;"></div>',
                                                hide: handleGetLandlordCommissionType(premiseDetail) === 'Hoa hồng theo doanh thu điện',
                                            },
                                            {
                                                description: '',
                                                value: `
                                                <div>
                                                    <div style="font-weight: 600; font-size: 14px; color: #494968;">
                                                        <span>Hoa hồng cố định</span>
                                                        <span style="font-weight: 500; color: #E14E54;">(Chi trả một lần duy nhất)</span>
                                                    </div>
                                                   <div style="border: 1px solid #DBDFF1; margin-top: 10px; border-radius: 5px; padding: 10px">
                                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                                            <div style="font-weight: 500; color: #6B7280;">Loại phương tiện</div>
                                                            <div style="font-weight: 600;">Ô tô</div>
                                                        </div>
                                                        <div style="border-top: 1px dashed #DBDFF1;"></div>
                                                        <div class="d-flex justify-content-between align-items-center mt-2">
                                                            <div style="font-weight: 500; color: #6B7280;">Số tiền cố định</div>
                                                            <div style="font-weight: 600;">${Utils.formatNumber(premiseDetail?.sales?.[0]?.premiseType?.car ?? 0)}</div>
                                                        </div>
                                                    </div>
                                                    <div style="border: 1px solid #DBDFF1; margin-top: 10px; border-radius: 5px; padding: 10px">
                                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                                            <div style="font-weight: 500; color: #6B7280;">Loại phương tiện</div>
                                                            <div style="font-weight: 600;">Xe máy</div>
                                                        </div>
                                                        <div style="border-top: 1px dashed #DBDFF1;"></div>
                                                        <div class="d-flex justify-content-between align-items-center mt-2">
                                                            <div style="font-weight: 500; color: #6B7280;">Số tiền cố định</div>
                                                            <div style="font-weight: 600;">${Utils.formatNumber(premiseDetail?.sales?.[0]?.premiseType?.bike ?? 0)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            `.trim(),
                                                hide: handleGetLandlordCommissionType(premiseDetail) === 'Hoa hồng theo doanh thu điện' || !landlordCommission?.show,
                                            },
                                            {
                                                value: Utils.formatNumber(premiseDetail?.sales?.[0]?.premiseType?.value ?? 0) + ' VNĐ',
                                                description: `
                                                    <div>
                                                        <span>Số tiền cố định</span>
                                                        <span style="font-weight: 500; color: #E14E54;">(Chi trả một lần duy nhất)</span>
                                                    </div>`,
                                                hide: handleGetLandlordCommissionType(premiseDetail) === 'Hoa hồng theo doanh thu điện' || !!landlordCommission?.show,
                                            },
                                        ]}
                                    />
                                }
                            </KTScrollCard>

                        </div>
                    }
                />

                <div className="my-3">
                    <AgencyContractListView premiseId={premiseId} contractListProps={contractList} agencyId={premiseDetail?.agencyId} showFullUI={true} ignoreFilterButton={true} ignoreCreateContractButton={true} />
                </div>
            </div>
        </div>
    );
}

export default PremiseDetailScreen;
